module.exports = __webpack_public_path__ + "static/media/ROU_Assets__Lease_Liability.96eba06a.svg";